import requestFunctions from "../../functions/requestFunctions";


export const state = {
  TEMPLATE_ITEM: {},
  TEMPLATE_LIST: [],
  TEMPLATE_TABLE_DATA: [],
  TEMPLATE_ARRAY_DATA: [],
  TEMPLATE_TOTAL_ROWS: 0
}

export const getters = {
  GET_TEMPLATE_ITEM: (state) => {
    return state.TEMPLATE_ITEM;
  },
  GET_TEMPLATE_LIST: (state) => {
    return state.TEMPLATE_LIST;
  },
  GET_TEMPLATE_TABLE_DATA: (state) => {
    return state.TEMPLATE_TABLE_DATA;
  },
  GET_TEMPLATE_ARRAY_DATA: (state) => {
    return state.TEMPLATE_ARRAY_DATA;
  },
  GET_TEMPLATE_TOTAL_ROWS: (state) => {
    return state.TEMPLATE_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_TEMPLATE_ITEM(state, item) {
    state.TEMPLATE_ITEM = item;
  },

  UPDATE_TEMPLATE_LIST(state, list) {
    
    state.TEMPLATE_LIST = list.data;

    state.TEMPLATE_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.TEMPLATE_TABLE_DATA = [];
    state.TEMPLATE_ARRAY_DATA = [];

    list.forEach(el => {

      state.TEMPLATE_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.TEMPLATE_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
      });
    });
  },
}

export const actions = {

  async FETCH_TEMPLATE_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/template/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TEMPLATE_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_TEMPLATE_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/template';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TEMPLATE_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_TEMPLATE_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/template';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_TEMPLATE_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/template/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_TEMPLATE_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/template/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}